import React, { useState, useEffect } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import UploadImg from "../../assets/images/icons/upload-img.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";

function UpdateCuisine() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedCuisine, setSelectedCuisine] = useState(null);

  // Get cuisine data from localStorage (set when edit button is clicked)
  useEffect(() => {
    const cuisineData = localStorage.getItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_CUISINE);
    if (cuisineData) {
      const parsedData = JSON.parse(cuisineData);
      setSelectedCuisine(parsedData);
      setFormData({
        name: parsedData.name || "",
        image: null, // Don't prefill image, let user choose new one
      });
      // Set existing image as preview
      if (parsedData.image) {
        setImagePreview(parsedData.image);
      }
    }
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Please enter cuisine name");
      return;
    }

    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(formData.name.trim())) {
      toast.error("Cuisine name should only contain letters and spaces");
      return;
    }

    // For update, image is optional (user can keep existing or upload new one)
    if (!formData.image && !selectedCuisine?.image) {
      toast.error("Please select an image");
      return;
    }

    setLoading(true);
    try {
      const submitData = new FormData();
      submitData.append("name", formData.name);

      // Only append image if user selected a new one
      if (formData.image) {
        submitData.append("image", formData.image);
      }

      const response = await handleApiCall("patch", `${endpoints.updateCuisine}/${id}`, submitData);

      if (response?.data?.code === 200) {
        toast.success(response?.data?.message || "Cuisine updated successfully!");
        // Clean up localStorage
        localStorage.removeItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_CUISINE);
        // Add a small delay to ensure toast is shown before navigation
        setTimeout(() => {
          navigate("/cuisine-list");
        }, 1000);
      }
      // API errors are already handled by handleApiCall
    } catch (error) {
      console.error("Error updating cuisine:", error);
      // Network errors are already handled by handleApiCall
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      image: null,
    });
    setImagePreview(null);
    // Clean up localStorage
    localStorage.removeItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_CUISINE);
    navigate("/cuisine-list");
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Update Cuisine</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? "Updating..." : "Update"}
                    </Button>
                    <Button type="button" className="rounded-lg ml-4 bg-white" onClick={handleCancel} disabled={loading}>
                      Cancel
                    </Button>
                  </div>
                </div>
                <div className="col-md-12 tab-content row px-0 mx-0">
                  <label className="imageUpload" role="button">
                    <input type="file" hidden accept="image/*" onChange={handleImageChange} />
                    {imagePreview ? (
                      <img src={imagePreview} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                    ) : (
                      <>
                        <img src={UploadImg} className="icon" />
                        <div className="text-white mt-1">Upload photo</div>
                      </>
                    )}
                  </label>
                </div>
                <h5 className="text-white mt-4 mb-3">CUISINE DETAILS</h5>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Cuisine Name" name="name" value={formData.name} onChange={handleInputChange} required />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateCuisine;
